// USDC token address on Base network
export const KOLZ_TOKEN_ADDRESS =
  process.env.NEXT_PUBLIC_KOLZ_TOKEN_ADDRESS || "0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913";
export const KOLZ_TOKEN_DECIMALS = process.env.NEXT_PUBLIC_KOLZ_TOKEN_DECIMALS || "6";
export const KOLZ_TOKEN_SYMBOL = process.env.NEXT_PUBLIC_KOLZ_TOKEN_SYMBOL || "USDC";
export const KOLZ_TOKEN_COINGECKO_ID = process.env.NEXT_PUBLIC_KOLZ_TOKEN_COINGECKO_ID || "tether";
// Uniswap V3 Factory contract address with fallback to Sepolia testnet
export const POOL_FACTORY_ADDRESS =
  (process.env.NEXT_PUBLIC_POOL_FACTORY_ADDRESS as `0x${string}`) || "0x0227628f3F023bb0B980b67D528571c95c6DaC1c"; // default sepolia
// Uniswap Quoter V2 contract address with fallback to Sepolia testnet
export const QUOTER_ADDRESS =
  (process.env.NEXT_PUBLIC_QUOTER_ADDRESS as `0x${string}`) || "0xEd1f6473345F45b75F8179591dd5bA1888cf2FB3"; // default sepolia
// Uniswap Swap Router contract address with fallback to Sepolia testnet
export const SWAP_ROUTER_ADDRESS =
  (process.env.NEXT_PUBLIC_SWAP_ROUTER_ADDRESS as `0x${string}`) || "0x3bFA4769FB09eefC5a80d6E87c3B9C650f7Ae48E"; // default sepolia

export const DEBOUNCE_TIME = 500; // Debounce time in milliseconds for input changes
export const SWAP_ROUTER_ABI = [
  {
    inputs: [
      {
        components: [
          { internalType: "address", name: "tokenIn", type: "address" },
          { internalType: "address", name: "tokenOut", type: "address" },
          { internalType: "uint24", name: "fee", type: "uint24" },
          { internalType: "address", name: "recipient", type: "address" },
          { internalType: "uint256", name: "amountIn", type: "uint256" },
          {
            internalType: "uint256",
            name: "amountOutMinimum",
            type: "uint256",
          },
          {
            internalType: "uint160",
            name: "sqrtPriceLimitX96",
            type: "uint160",
          },
        ],
        internalType: "struct IV3SwapRouter.ExactInputSingleParams",
        name: "params",
        type: "tuple",
      },
    ],
    name: "exactInputSingle",
    outputs: [{ internalType: "uint256", name: "amountOut", type: "uint256" }],
    stateMutability: "payable",
    type: "function",
  },
];
